import React, { ComponentProps, useState } from 'react';
import { asFetchableView, useRefreshView } from '../../../_lib/ViewFetcher';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SonForm } from '../../../_lib/Form2';
import { PageMembershipMatchingAttributesList } from '../partials/PageMembershipMatchingAttributesList';
import { Icons } from '../../../components/atoms/SVG';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { useDelayed } from '../../../hooks/useDelayed';
import { PageMembershipMatchingAttributesEditForm } from '../partials/PageMembershipMatchingAttributesEditForm';

type PageMembershipMatchingAttributesEditableListProps = {
  addForm: SonForm<any>;
  matchingAttributes: string[] | undefined;
};

function PageMembershipMatchingAttributesEdit({
  addForm,
  matchingAttributes,
}: PageMembershipMatchingAttributesEditableListProps) {
  const { t } = useSonTranslation('PageMembershipMatchingAttributes');
  const { refreshView } = useRefreshView();

  const [showModal, setShowModal] = useState(false);

  const closeModalAndRefreshDelayed = useDelayed(() => {
    setShowModal(false);
    refreshView();
  });

  return (
    <>
      <BlockBar heading={t('editPageMembershipMatchingAttributes')} hierarchy={3}>
        <BlockBarButton
          text={t('editPageMembershipMatchingAttributes')}
          svgSpriteId={Icons.EDIT_PENCIL}
          onClick={() => {
            setShowModal(!showModal);
          }}
        />
      </BlockBar>
      {showModal ? (
        <ModalDialog
          closeModal={() => setShowModal(false)}
          headline={t('editPageMembershipMatchingAttributes')}
          initialFocusIndex={1}
        >
          <PageMembershipMatchingAttributesEditForm form={addForm} onSuccess={closeModalAndRefreshDelayed} />
        </ModalDialog>
      ) : null}
      <PageMembershipMatchingAttributesList matchingAttributes={matchingAttributes} />
    </>
  );
}

export const PageMembershipMatchingAttributesEditView = asFetchableView(PageMembershipMatchingAttributesEdit);
export type PageMembershipMatchingAttributesEditView = ComponentProps<typeof PageMembershipMatchingAttributesEditView>;
